import { useState, useCallback } from 'react';

export type PWJ220Mode = 'browse' | 'add' | 'edit';

export function usePWJ220Mode() {
  const [mode, setMode] = useState<PWJ220Mode>('browse');

  const toAdd = useCallback(() => setMode('add'), []);
  const toEdit = useCallback(() => setMode('edit'), []);
  const toView = useCallback(() => setMode('browse'), []);

  const isEditing = mode === 'add' || mode === 'edit';

  return { mode, setMode, toAdd, toEdit, toView, isEditing };
}
